import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  btcToUsdtRate: 1,
};
export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BTC_TO_USDT_RATE_SUCCESS:
      return { ...state, btcToUsdtRate: action.data };
    default:
      return state;
  }
};
